// Header JS

// NAV CLICKS
const menuDropdown = document.querySelectorAll(".menu-dropdown");
for (var i = menuDropdown.length - 1; i >= 0; i--) {
	menuDropdown[i].addEventListener("click", function() {
		let parentEl = this.parentNode;
		let childMenu = parentEl.querySelector(".tier_1__ul");
		this.classList.toggle("is-active");
		childMenu.classList.toggle("active-sub-menu");
	});
}

// HEADER - STICKY
document.addEventListener("DOMContentLoaded", function() {
	let headerController = new ScrollMagic.Controller({
		addIndicators: false
	});
	let headerScene = new ScrollMagic.Scene({
		triggerHook: 0,
		triggerElement: "#container__site",
		offset: 150
	})
		.setClassToggle("#site__header", "scroll_header")
		.addTo(headerController);

	headerScene.on("enter leave", function(e) {
		const brandLogo = document.querySelector("#brand__logo");
		if (!brandLogo) {
			return;
		}

		const svgDoc = brandLogo.contentDocument;
		const brandSVG = svgDoc.querySelector("svg");
		const brandText = svgDoc.querySelector("#TEXT");

		if (e.type === "enter") {
			brandText.style = "display: none;";
			brandSVG.setAttribute("viewBox", "0 0 1256 500");
		} else {
			brandText.style = "display: block;";
			brandSVG.setAttribute("viewBox", "0 0 1256 768");
		}
	});
});
